<template>  
    <EnrollmentsEditTabAccount class="pt-75" @changed-query="fetchEnrollmentsData"  />
</template>

<script>
import { onUnmounted, provide, ref } from '@vue/composition-api'
import EnrollmentsEditTabAccount from './EnrollmentsEditTabAccount.vue'
import enrollmentsStoreModule from '../enrollmentsStoreModule'
import router from '@/router'
import store from '@/store'

export default {
    components: { EnrollmentsEditTabAccount },

    setup() {
        const ENROLLMENT_MODULE_NAME = 'enrollments'
        const enrollment = ref(null)
        const students = ref([])
        const courses = ref([])
        const groups = ref([])
        const terms=ref([])
        const studentsQuery=ref(null)
        const coursesQuery=ref(null)

        provide('enrollment', enrollment)
        provide('students', students)
        provide('courses', courses)
        provide('groups', groups)
        provide('terms', terms)
        provide('studentsQuery', studentsQuery)
        provide('coursesQuery', coursesQuery)

        if(!store.hasModule(ENROLLMENT_MODULE_NAME)) store.registerModule(ENROLLMENT_MODULE_NAME, enrollmentsStoreModule)
        
        onUnmounted(() => {
            if(store.hasModule(ENROLLMENT_MODULE_NAME)) store.unregisterModule(ENROLLMENT_MODULE_NAME)
        })

        // Consultar los estudiantes y cursos del select
        const fetchEnrollmentsData = () => {
            store.dispatch('enrollments/createEnrollment', {
            students_query: studentsQuery.value, 
            courses_query: coursesQuery.value, 
        }).then(response => {
            students.value = response.data.students
            courses.value = response.data.courses
            terms.value=response.data.terms
            groups.value=response.data.groups
        })
        }

        // Consultar la matrícula
        store.dispatch('enrollments/editEnrollment', { id: router.currentRoute.params.id }).then(response => {
            enrollment.value = response.data.enrollment
        })
        
        fetchEnrollmentsData()


        return {
            fetchEnrollmentsData
        }




    }
}
</script>

<style>

</style>